export const homepageBannerSideBarNav = {
    _name: "CSidebarNavItem",
    name: "Homepage Banner",
    to: "/management/banners",
    icon: "banner-homepage",
}

export const electronicDeliveryOrderSideBarNav ={
        _name: "CSidebarNavItem",
        name: "E-DO",
        to: "/management/e-do",
        icon: "cil-description"
}

export const AgentTopUpSideBarNav = (topUpFlag)=> {
       return  {
          name: "Top Up",
          to: "/agent/top-up",
          badge: {
                color: "danger",
                text: topUpFlag
            }
       }
}